import React from "react";


export function BillingContainer({ accessToken, name, email }) {
  return(
      <p>Billing</p>
  )
}
 